import React from 'react';
export function Footer() {
  return <footer className="w-full px-4 py-8 bg-[#0f172a] border-t border-gray-700" data-id="element-61">
      <div className="max-w-6xl mx-auto text-center" data-id="element-62">
        <p className="text-gray-500 text-sm" data-id="element-63">
          © 2024 MegaPack KineEficiente. Todos los derechos reservados.
        </p>
        <p className="text-gray-600 text-xs mt-2" data-id="element-64">
          Sistema diseñado para kinesiólogos profesionales
        </p>
      </div>
    </footer>;
}